<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yPEYuz/tc-custom/CoverDesign.jpg?1685204507412?1685571442567" alt="This image is the cover for the book Alpha Wave, The Elusive Spark"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alpha Wave, The Elusive Spark
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Elusive Spark: Book Two</i></b></p><p>Keira Fairchild is running for her life, and she won’t make it far without someone watching her back.</p> <p>Her powers helped her elude a slave trader, Holcomb, who planned to sell her to the highest bidder, and the deadly Paragon Academy. But now Keira needs some allies and some answers. Who is the imprisoned alien being who keeps contacting her in her dreams? Keira is aided by a group of teens—James, Lumen, and Paul—with powers like her own, and all of them are ready for a fight. The small group must rescue the captive alien and escape Dr. Albion, who seeks to steal their abilities and eliminate them. Survival will mean a desperate struggle, and none of them can succeed on their own.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Demcak
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harmony Ink Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e25eb996